import React from "react";
import { Modal } from "react-bootstrap";
import celebrationImg from "../../assets/images/celebrationImg.png";

const CustomModal = ({
  id,
  size = "md",
  contentClassName = "",
  scrollable,
  ...props
}) => {
  const { giftImages, title, content, footer, show, onHide } = props;

  return (
    <Modal
      id={id}
      show={show}
      onHide={onHide}
      size={size}
      className="custom-modal"
      dialogClassName="custom-modal__dialog"
      contentClassName={`custom-modal__content ${contentClassName}`.trim()}
      backdropClassName="custom-modal__backdrop"
      backdrop="static"
      centered
      scrollable={scrollable ?? size === "lg"}
      aria-labelledby={id ? `${id}-title` : "custom-modal-title"}
    >
      {giftImages && (
        <img
          src={celebrationImg}
          alt=""
          className="img-fluid celebrationImg"
          aria-hidden="true"
        />
      )}

      {title && (
        <Modal.Header className="custom-modal__header border-0 pb-0">
          <Modal.Title
            id={id ? `${id}-title` : "custom-modal-title"}
            className="custom-modal__title w-100"
          >
            {title}
          </Modal.Title>
        </Modal.Header>
      )}

      <Modal.Body className="custom-modal__body">{content}</Modal.Body>

      {footer != null && footer !== false && (
        <Modal.Footer className="custom-modal__footer border-0 pt-0">
          {footer}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CustomModal;
